import type { LightGalleryCoreSettings } from 'lightgallery/lg-settings';
import type { GalleryItem as LightGalleryItem } from 'lightgallery/lg-utils';
import type {
  MediaSourceSize,
  MediaViewerSlideTransition,
} from '../media-viewer.types';

export interface LightGalleryConfig {
  readonly licenseKey: string;
}

/** Shows `src` first, then swaps to `fullSrc` once it has loaded. */
export interface ViewerSlideItem extends LightGalleryItem {
  readonly fullSrc?: string;
  readonly fullSize?: MediaSourceSize;
}

export const lightGalleryTransitionMap: {
  [key in MediaViewerSlideTransition]: LightGalleryCoreSettings['mode'];
} = {
  slide: 'lg-slide',
  'slide-vertical': 'lg-slide-vertical',
  fade: 'lg-fade',
  'zoom-in': 'lg-zoom-in',
  'zoom-out': 'lg-zoom-out',
};

export const lightGalleryThumbnailProperty = 'data-lg-thumb-image';

export const lightGalleryItemSelector = 'fl-media-viewer-item';

export interface LightGalleryVideoSource {
  source: { src: string; type?: string }[];
  attributes: {
    preload: boolean;
    controls: boolean;
  };
}
